import { QueryKeys } from '../../utils/queryKeys';

export const postCourseAssessmentKeys = {
    all: [QueryKeys.GET_POST_ASSESSMENT_QUESTION],
    getPostCourseAssessmentKeys: () => [...postCourseAssessmentKeys.all],
};